// 出库单列表
export const getOutboundOrderList = (params) => {
  return window._this.$http.get(`/go/stock/other/stock_out_order`, {
    params,
  });
};

// 发货单列表
export const getShippingOrderList = (params) => {
  return window._this.$http.get(`/go/stock/other/delivery_order`, {
    params,
  });
};

// 发货单操作日志列表
export const getShippingLogList = (params) => {
  return window._this.$http.get(`/go/stock/other/delivery_order/opt_log`, {
    params,
  });
};

// 可售商品列表
export const getAvailableProducts = (params) => {
  return window._this.$http.get(`/go/stock/other/stock_goods`, {
    params,
  });
};

// 拣货单列表
export const getPickingOrderList = (params) => {
  return window._this.$http.get(`/go/stock/other/picking_order`, {
    params,
  });
};

// 更新发货单详情
export const updateShippingOrderInfo = (params) => {
  return window._this.$http.put(
    `/go/stock/other/delivery_order_detail`,
    params,
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
};

// 添加发货单详情
export const createShippingOrder = (params) => {
  return window._this.$http.post(
    `/go/stock/other/delivery_order_detail`,
    params,
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
};

// 获取出库单详情
export const getOutboundOrderDetail = (params) => {
  console.log("🚀 ~ file: stock.js ~ line 64 ~ params", params);
  return window._this.$http.get(
    `/go/stock/other/stock_out_order_detail/${params.stock_out_order_id}`,
    {
      params,
    }
  );
};

// 获取发货单详情
export const getShippingOrderDetail = (params) => {
  return window._this.$http.get(
    `/go/stock/other/delivery_order_detail/${params.order_id}`,
    {
      params,
    }
  );
};

// 获取拣货单详情
export const getPickingOrderDetail = (params) => {
  return window._this.$http.get(
    `/go/stock/other/picking_order_detail/${params.picking_order_id}`,
    {
      params,
    }
  );
};

// 获取拣货单详情
export const searchSupplyName = (params) => {
  return window._this.$http.get(`/go/stock/other/supply_name`, {
    params,
  });
};

// 仓库列表接口
export const searchWarehouse = (params) => {
  return window._this.$http.get(`/go/stock/stock_storehouse`, {
    params,
  });
};

// 仓库调动接口
export const mobilizeWarehouse = (params) => {
  return window._this.$http.patch(
    `/go/stock/stock_storehouse_personnel`,
    params
  );
};

// 仓库人员列表
export const getWarehouseWorkers = (params) => {
  return window._this.$http.get(`/go/stock/stock_storehouse_personnel`, {
    params,
  });
};
// 获取所有管理员信息
export const getManagerList = (params) => {
  return window._this.$http.get(`/go/stock/admin_info`, {
    params,
  });
};
// 通过管理员姓名获取相关信息
export const getManagerInfo = (params) => {
  return window._this.$http.get(`/go/stock/admin_info/admin_name`, {
    params,
  });
};

// 创建仓库人员
export const createWarehouseWorker = (params) => {
  return window._this.$http.post(
    `/go/stock/stock_storehouse_personnel`,
    params
  );
};
// 创建仓库
export const createWarehouse = (params) => {
  return window._this.$http.post(`/go/stock/stock_storehouse`, params);
};

// 获取商家名称
export const getSupplyName = (params) => {
  return window._this.$http.get(`/go/stock/supply_name_search`, { params });
};

// 获取商家报表列表
export const getReportList = (params) => {
  return window._this.$http.get(`/go/stock/pre_storage_report`, { params });
};

// 前置仓报表-详情
export const getPreStockReportDetial = (params) => {
  return window._this.$http.get(`/go/stock/pre_storage_report_detail`, {
    params,
  });
};

// 获取商品锁定库存列表
export const getStoreLockList = (params) => {
  return window._this.$http.get(`/erp/Goods/listGoodsStockLock`, { params });
};

// 获取商品锁定库存日志列表
export const getStoreLockLogList = (params) => {
  return window._this.$http.get(`/erp/Goods/listGoodsStockLog`, { params });
};



// WEBPACK FOOTER //
// ./src/api/stock.js